"use strict";
exports.__esModule = true;
exports.SvgToolbarPaste = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgToolbarPaste = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M12.083 1.6c.88 0 1.62.592 1.846 1.4H15.5a1 1 0 011 1v13a1 1 0 01-1 1h-11a1 1 0 01-1-1V4a1 1 0 011-1h1.57a1.92 1.92 0 011.683-1.393l.164-.007h4.166zm-5.9 2.9H5v12h10v-12h-1.183a1.914 1.914 0 01-1.571 1.093l-.163.007H7.917c-.767 0-1.428-.45-1.734-1.1zm4.88-1.5H10c-.704 0-1.407-.001-2.11.001a.63.63 0 00-.641.613.635.635 0 00.635.634c1.412.003 2.823.002 4.235 0 .14 0 .271-.042.383-.13a.622.622 0 00-.379-1.116L11.063 3z" }),
        react_1["default"].createElement("path", { d: "M0 0h20v20H0z" })))); };
//# sourceMappingURL=ToolbarPaste.js.map